<template>
  <div>
    <el-row style="margin-top:20px">
      <el-col>
        <el-form size="small" :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" :picker-options="pickerOptions" v-model="searchForm.SEND_DAY" type="date"
              placeholder="选择日期" :clearable="false"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="doQueryTable()">筛选</el-button>
            <el-button size="medium" type="primary" plain @click="exportTable()">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="FULL_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="销售价"></el-table-column>
          <el-table-column prop="VENDOR_PRICE" label="采购价"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="TC_NAME" label="团餐公司"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="门店"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryPurchaseAudit } from '@/assets/api/sellOrder';
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {
        SEND_DAY: date(new Date().getTime() + 3600 * 1000 * 24, '%F'),
      },
      pickerOptions: {
        disabledDate(time) {
          const nowD = new Date();
          return time.getTime() < nowD.getTime();
        },
      },
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      queryPurchaseAudit().then((result) => {
        if (result.length !== 0) {
          this.tableData = result.map((item) => Object.assign(item, {
            PRODUCT_CODE: item.PRODUCT_CODE.toString(),
          }));
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    doQueryTable() {
      const params = {
        SERVICE_ID: '10174',
        OTYPE: 9,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result;
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportTable() {
      const params = {
        SERVICE_ID: '10174',
        OTYPE: 11,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      http.post(params)
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sellOrderManage/purchaseAudit.vue